import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import { useStaticQuery, graphql } from 'gatsby';

function SEO({ description, lang, title, metaTitle }) {
    const { site } = useStaticQuery(
        graphql`
            query {
                site {
                    siteMetadata {
                        siteUrl
                        title
                        description
                        image
                    }
                }
            }
        `
    );

    const metaDescription = description || site.siteMetadata.description;

    return (
        <Helmet
            htmlAttributes={{
                lang
            }}
            title={metaTitle}
            titleTemplate={`%s`}
        >
            <meta
                name="viewport"
                content="width=device-width, initial-scale=1"
            />
            <meta name="robots" content="index, follow" />
            <meta name="referrer" content="origin" />
            <meta name="title" content={`${metaTitle}`} />
            <meta name="description" content={metaDescription} />
            <meta name="og:title" content={`${metaTitle}`} />
            <meta name="og:image" content="/images/og.png" />
            <meta name="og:description" content={metaDescription} />
            <meta name="og:type" content="website" />
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={`${metaTitle}`} />
            <meta
                name="twitter:image"
                content="https://headshotphotos.in/images/og.png"
            />
            <meta name="twitter:description" content={metaDescription} />
            <meta itemProp="name" content={`${metaTitle}`} />
            <meta itemProp="image" content="/images/og.png" />
            <meta itemProp="description" content={metaDescription} />
        </Helmet>
    );
}

SEO.defaultProps = {
    lang: `en`,
    description: ``
};

SEO.propTypes = {
    description: PropTypes.string,
    lang: PropTypes.string,
    title: PropTypes.string.isRequired
};

export default SEO;
